import type { routes, SharedTypes } from '@semios/app-platform-banyan-route-definitions'
import { isEmpty } from '@semios/app-platform-common'
import { IRRIGATION_ACTIVITY_FLOW_METER_VALUE_TYPE_PREFIX } from '@semios/app-platform-values-helpers-and-types'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import type { TSelectedFieldAssetsStoreState } from 'stores/selectedFieldAssetsStore/selectedFieldAssetsStore'
import type { selectedValueGroupsStore } from 'stores/selectedValueGroupsStore/selectedValueGroupsStore'

export const apiArgsForIrrigationFlowMeter = ({
  selectedValueGroups,
  selectedFieldAssets,
}: {
  selectedValueGroups: ReturnType<typeof selectedValueGroupsStore.getState>['selectedValueGroups']
  selectedFieldAssets: TSelectedFieldAssetsStoreState
}): Partial<routes.Values.Request> => {
  if (!selectedValueGroups.irrigation_activity_flow_meters || !selectedFieldAssets.property) return {}

  const preferredAggregationInterval = {
    preferredAggregationInterval: 'DAILY',
  }

  const property = fieldAssetStore.getState().properties?.[selectedFieldAssets.property]

  if (!property) return {}

  const lngLats: SharedTypes.TLngLat[] = []

  const valuesRequested: Record<string, typeof preferredAggregationInterval> = {
    irrigationFlowMeter: preferredAggregationInterval,
  }

  Object.values(property.points || {}).forEach((point) => {
    const valueTypesForFlowMeter = point.valuesTimeseries.filter((vt) =>
      vt.includes(IRRIGATION_ACTIVITY_FLOW_METER_VALUE_TYPE_PREFIX),
    )

    if (valueTypesForFlowMeter.length > 0) {
      lngLats.push(point.lngLat)
    }
  })

  if (isEmpty(lngLats) || isEmpty(valuesRequested)) return {}

  return {
    points: {
      lngLats: lngLats,
      valuesRequested,
    },
  }
}
